import { temAcesso } from '@/shared/auth/temAcesso'

const Relatorios = () => import('./Relatorios.vue')
const ComprometimentosSemRegistroPagamento = () =>
    import('./planilhas/ComprometimentosSemRegistroPagamento.vue')
const RelacaoNotasFiscais = () =>
    import('./planilhas/RelacaoNotasFiscais.vue')
const ComprometimentosPorContrato = () =>
    import('./planilhas/ComprometimentosPorContrato.vue')
const ContratosPorGestor = () =>
    import('./planilhas/ContratosPorGestor.vue')
const ValoresPagosPorContratos = () =>
    import('./planilhas/ValoresPagosPorContratos.vue')
const ContratosAnuais = () =>
    import('./planilhas/ContratosAnuais.vue')
const SaldoAnualContratos = () =>
    import('./paineis/SaldoAnualContratos.vue')

export default {
    path: 'contratos/relatorios',
    name: 'Contratos_Relatorios',
    component: Relatorios,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CONT-REL-00')) {
            next()
        }
    },
    children: [
        {
            path: 'planilhas/comprometimentossemregistropagamento',
            name: 'Contratos_Relatorios_ComprometimentosSemRegistroPagamento',
            component: ComprometimentosSemRegistroPagamento,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REL-01')) {
                    next()
                }
            }
        },
        {
            path: 'planilhas/relacaonotasfiscais',
            name: 'Contratos_Relatorios_RelacaoNotasFiscais',
            component: RelacaoNotasFiscais,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REL-02')) {
                    next()
                }
            }
        },
        {
            path: 'planilhas/comprometimentosporcontrato',
            name: 'Contratos_Relatorios_ComprometimentosPorContrato',
            component: ComprometimentosPorContrato,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REL-03')) {
                    next()
                }
            }
        },
        {
            path: 'planilhas/contratosporgestor',
            name: 'Contratos_Relatorios_ContratosPorGestor',
            component: ContratosPorGestor,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REL-04')) {
                    next()
                }
            }
        },
        {
            path: 'planilhas/valorespagosporcontratos',
            name: 'Contratos_Relatorios_ValoresPagosPorContratos',
            component: ValoresPagosPorContratos,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REL-05')) {
                    next()
                }
            }
        },
        {
            path: 'planilhas/contratosanuais',
            name: 'Contratos_Relatorios_ContratosAnuais',
            component: ContratosAnuais,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-REL-06')) {
                    next()
                }
            }
        },
        {
            path:'paineis/saldoanualcontratos',
            name: 'Contratos_Relatorios_SaldoAnualContratos',
            component: SaldoAnualContratos,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-PNL-01')) {
                    next()
                }
            }
        }
    ]
}
